import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { selectUser } from "../../redux/slices/userSlice";

const BottombarLink = ({ link, setShowLoginModal }) => {
  const user = useSelector(selectUser);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleLinkClick = (e) => {
    e.preventDefault();
    if (!user?._id && link.loginRequired) {
      return setShowLoginModal(true);
    }

    navigate(link.path);
  };

  return (
    <Link
      href={link.path}
      onClick={handleLinkClick}
      className={`text-xs vsm:text-sm md:text-lg cursor-pointer flex flex-col justify-center items-center gap-[7px] md:gap-[8px] ${
        pathname === link.path ? "text-[#F0EF2A]" : ""
      }`}
    >
      {link.icon}
      {link.text}
    </Link>
  );
};

export default BottombarLink;
